import { GoogleOAuthProvider } from "@react-oauth/google";
import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import { RouterProvider } from "react-router";
import "./lib/auth";
import "./lib/i18n";
import "./lib/sentry";
import "./index.css";
import { Toaster } from "sonner";
import { AuthProvider } from "./components/AuthProvider";
import { ErrorBoundary } from "./components/ErrorBoundary";
import { UnsavedChangesProvider } from "./components/UnsavedChangesProvider";
import { detectLocaleFromURL, getBasename } from "./lib/locale";
import { captureMarketingAttributionFromCurrentLocation } from "./lib/marketingAttribution";
import { createRouter } from "./router";

captureMarketingAttributionFromCurrentLocation();

const locale = detectLocaleFromURL();
const router = createRouter(getBasename(locale));
const googleClientId = import.meta.env.VITE_GOOGLE_CLIENT_ID as string | undefined;

const rootElement = document.getElementById("root");
if (!rootElement) throw new Error("Root element not found");

const content = (
	<ErrorBoundary>
		<UnsavedChangesProvider>
			<AuthProvider>
				<RouterProvider router={router} />
			</AuthProvider>
		</UnsavedChangesProvider>
		<Toaster richColors position="bottom-right" />
	</ErrorBoundary>
);

const app = googleClientId ? (
	<GoogleOAuthProvider clientId={googleClientId}>{content}</GoogleOAuthProvider>
) : (
	content
);

createRoot(rootElement).render(<StrictMode>{app}</StrictMode>);
